export * from './Star20mm';